import type { AccGroup } from '@/api/accountsBooks';

/** Groups in tree order (each parent followed by its children, API order kept) with their depth. */
export function groupTree(groups: AccGroup[]): { g: AccGroup; depth: number }[] {
  const out: { g: AccGroup; depth: number }[] = [];
  const ids = new Set(groups.map((g) => g.id));
  const walk = (parentId: number | null, depth: number) => {
    for (const g of groups) {
      const isRoot = parentId === null ? g.parentId === null || !ids.has(g.parentId) : g.parentId === parentId;
      if (isRoot) { out.push({ g, depth }); walk(g.id, depth + 1); }
    }
  };
  walk(null, 0);
  return out;
}
